import GroupsIcon from '@mui/icons-material/Groups';
import { Button } from '@mui/material';

const CreateGroupButton = ({ handleClick }) => {
  return (
    <Button
      onClick={handleClick}
      sx={{
        width: "fit-content",
        backgroundColor: "#636AE8",
        color: "#FFFFFF",
        padding: "20px",
        borderRadius: "50%",
        position: "fixed",
        bottom: "20px",
        right: "100px",
      }}
      variant="contained"
    >
      <GroupsIcon />
    </Button>
  );
};

export default CreateGroupButton;
